module.exports = __webpack_public_path__ + "img/bone-break.f3f727dc.svg";